<div class="status-history-page-container container" fxLayout="column" fxLayoutGap="15px">
  <p>{{ 'STORE_VISIT_INFO' | translate }}</p>
  <div>
    <mtn-key-value [key]="'STORE_OPENING_DATE' | translate">
      <span *ngIf="store.actualOpenedDate; else notAvailable">{{store.actualOpenedDate | insightsDate}}</span>
    </mtn-key-value>
    <mtn-key-value [key]="'STORE_CLOSED_DATE' | translate" *ngIf="store.actualClosedDate">
      <span>{{store.actualClosedDate | insightsDate}}</span>
    </mtn-key-value>
  </div>
  <mtn-simple-panel color="blue">
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
      <fa-icon icon="info-circle" size="2x"></fa-icon>
      <span>{{ 'STATUS_UPDATE_INFO' | translate }}</span>
    </div>
  </mtn-simple-panel>
  <hr/>
  <div class="table-container container condensed-table">
    <table mat-table [dataSource]="dataSource" matSort matSortActive="date" matSortDirection="desc">
      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'FIRST_OBSERVED_DATE' | translate }}</th>
        <td mat-cell *matCellDef="let status">
          <span>{{status.statusDate | insightsDate}}</span>
        </td>
      </ng-container>
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'STATUS' | translate }}</th>
        <td mat-cell *matCellDef="let status">
          <mtn-store-status-view [type]="status.getStatusSystemName()"></mtn-store-status-view>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

    </table>
    <mat-paginator [pageSize]="5" [showFirstLastButtons]="true" [length]="dataSource.data?.length"
                   [hidePageSize]="true" [hidden]="dataSource.data?.length <= 5"></mat-paginator>
  </div>
</div>

<ng-template #notAvailable>
  <span class="color-muted">{{ 'NOT_AVAILABLE' | translate }}</span>
</ng-template>
